import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_spot_ask_box.svg'
import _imports_1 from '@/app/ui/assets/svg/vendor-dex-icon.svg'


const _hoisted_1 = {
  "data-testid": "dex-reconcile-scan-rekon-sidebar-entity",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col gap-3 animate-pulse" }, [
  /*#__PURE__*/_createVNode("div", { class: "h-5 w-3/4 rounded bg-gray-lp-1400" }),
  /*#__PURE__*/_createVNode("div", { class: "h-4 w-full rounded bg-gray-lp-1400" }),
  /*#__PURE__*/_createVNode("div", { class: "h-4 w-1/2 rounded bg-gray-lp-1400" }),
  /*#__PURE__*/_createVNode("div", { class: "rounded-xl bg-gray-lp-1900 p-3 flex flex-col gap-3" }, [
    /*#__PURE__*/_createVNode("div", { class: "h-8 w-full rounded bg-gray-lp-1400" }),
    /*#__PURE__*/_createVNode("div", { class: "h-8 w-full rounded bg-gray-lp-1400" })
  ])
], -1)
const _hoisted_3 = { class: "w-full h-full justify-center items-center flex flex-col mx-auto text-sm overflow-hidden py-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "mx-auto w-20 h-20",
  alt: "ill_spot_ask_box"
}, null, -1)
const _hoisted_5 = { class: "text-black-lp-300 font-semibold pt-4" }
const _hoisted_6 = { class: "text-gray-lp-600 py-2 text-center" }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col gap-y-2"
}
const _hoisted_8 = { class: "flex items-center gap-x-2 rounded-md bg-gray-lp-1500 p-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "vendor-dex-icon"
}, null, -1)
const _hoisted_10 = { class: "flex flex-col flex-1 min-w-0" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text-black-lp-100 text-xs font-medium" }, " VENDOR ", -1)
const _hoisted_12 = { class: "text-black-lp-300 text-xl font-bold truncate" }
const _hoisted_13 = { class: "flex flex-col divide-y divide-gray-lp-1500" }
const _hoisted_14 = { class: "flex items-center justify-between gap-x-4 py-4" }
const _hoisted_15 = { class: "flex items-center gap-x-2 text-black-lp-100" }
const _hoisted_16 = { class: "text-xs font-medium" }
const _hoisted_17 = { class: "flex items-center gap-x-2 text-black-lp-300" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, " STT ", -1)
const _hoisted_20 = { class: "flex items-center justify-between gap-x-4 py-4" }
const _hoisted_21 = { class: "flex items-center gap-x-2 text-black-lp-100" }
const _hoisted_22 = { class: "text-xs font-medium" }
const _hoisted_23 = { class: "flex items-center gap-x-2 text-black-lp-300" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "flex items-center justify-between gap-x-4 py-4" }
const _hoisted_26 = { class: "flex items-center gap-x-2 text-black-lp-100" }
const _hoisted_27 = { class: "text-xs font-medium" }
const _hoisted_28 = { class: "flex items-center gap-x-2 text-black-lp-300" }
const _hoisted_29 = { class: "font-bold" }
const _hoisted_30 = { class: "flex items-center justify-between gap-x-4 py-4" }
const _hoisted_31 = { class: "flex items-center gap-x-2 text-black-lp-100" }
const _hoisted_32 = { class: "text-xs font-medium" }
const _hoisted_33 = { class: "flex items-center gap-x-2 text-black-lp-300" }
const _hoisted_34 = { class: "font-bold" }
const _hoisted_35 = { class: "font-semibold text-lg text-black-lp-100 px-8 py-5 w-full text-center" }
const _hoisted_36 = {
  class: "flex flex-col gap-y-6 relative px-8 pb-8 font-montserrat bg-white rounded-b-lg",
  style: {"max-height":"max-content"}
}
const _hoisted_37 = { class: "flex items-center gap-x-2 w-full" }
const _hoisted_38 = { class: "flex flex-col w-full" }
const _hoisted_39 = { class: "flex items-center gap-x-2" }
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-gray-lp-600"
}
const _hoisted_41 = { class: "flex items-center gap-x-4 justify-between rounded-b-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 0,
            class: "p-3 flex flex-col flex-1",
            rounded: "xl",
            isShadow: false,
            style: {"height":"max-content"}
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : (_ctx.isEmpty)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              class: "p-3 flex flex-col flex-1",
              rounded: "xl",
              isShadow: false,
              style: {"height":"max-content"}
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("handoverV2.update.sidebar.empty.title")), 1),
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("handoverV2.update.sidebar.empty.message")), 1)
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_Card, {
                class: "p-1 flex flex-col flex-1",
                rounded: "xl",
                isShadow: false,
                style: {"height":"max-content"}
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.lastScanRow.vendorName), 1)
                    ])
                  ]),
                  (_ctx.eligibleVendorList.length > 1)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        flat: "",
                        dense: "",
                        title: _ctx.$t('handoverV2.update.sidebar.changeVendor'),
                        textColor: "red-lp-300",
                        isWidthFull: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openChangeVendor = true)),
                        class: "my-2"
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.isVendorInternal)
                    ? (_openBlock(), _createBlock(_component_LpInput, {
                        key: 1,
                        modelValue: _ctx.lastScanRow.remarks,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.lastScanRow.remarks = $event)),
                        placeholder: 
              _ctx.$t('handoverV2.update.sidebar.placeholderInputVendorNameInternal')
            ,
                        marginVertical: "my-0"
                      }, null, 8, ["modelValue", "placeholder"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Card, {
                class: "p-3 flex flex-col gap-y-4 flex-1",
                rounded: "xl",
                isShadow: false,
                style: {"height":"max-content"}
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode(_component_Icons, {
                          name: "box",
                          class: "w-5"
                        }),
                        _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("handoverV2.update.sidebar.totalStt")), 1)
                      ]),
                      _createVNode("div", _hoisted_17, [
                        _createVNode("span", _hoisted_18, _toDisplayString(_ctx.summary.totalStt), 1),
                        _hoisted_19
                      ])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode(_component_Icons, {
                          name: "piece",
                          class: "w-5"
                        }),
                        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("handoverV2.update.sidebar.totalPieces")), 1)
                      ]),
                      _createVNode("div", _hoisted_23, [
                        _createVNode("span", _hoisted_24, _toDisplayString(_ctx.summary.totalKoli), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _createVNode(_component_Icons, {
                          name: "weight-kg",
                          class: "w-5"
                        }),
                        _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("handoverV2.update.sidebar.totalGrossWeight")), 1)
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _createVNode("span", _hoisted_29, _toDisplayString(_ctx.summary.totalGrossWeight) + " kg ", 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        _createVNode(_component_Icons, {
                          name: "dex",
                          class: "w-5"
                        }),
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("handoverV2.update.sidebar.totalVolumeWeight")), 1)
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.summary.totalVolumeWeight) + " kg ", 1)
                      ])
                    ])
                  ]),
                  _createVNode(_component_LpButton, {
                    iconV2: true,
                    iconLeft: "generate",
                    sizeIcon: "w-5",
                    iconColor: "white",
                    iconGroupHoverColor: "white",
                    title: _ctx.$t('handoverV2.update.sidebar.processHandover'),
                    textColor: "white",
                    isWidthFull: "",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('process'))),
                    disabled: _ctx.disabledProcess
                  }, null, 8, ["title", "disabled"]),
                  _createVNode(_component_LpButton, {
                    flat: "",
                    dense: "",
                    title: _ctx.$t('handoverV2.update.sidebar.cancel'),
                    textColor: "red-lp-300",
                    isWidthFull: "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('clear-all')))
                  }, null, 8, ["title"])
                ]),
                _: 1
              })
            ]))
    ]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.openChangeVendor,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.openChangeVendor = $event)),
      persistent: "",
      customBody: "p-0",
      customWidth: "w-500px"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("handoverV2.update.changeVendor.title")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_36, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('handoverV2.update.changeVendor.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                class: "w-full mt-1.5",
                placeholder: _ctx.$t('handoverV2.update.changeVendor.placeholder'),
                options: _ctx.vendorOptions,
                onSelect: _ctx.onSelectVendor,
                selectedItem: _ctx.newVendor,
                isDisabled: false,
                disableBackground: false
              }, {
                label: _withCtx(({ label }) => [
                  _createVNode("div", _hoisted_37, [
                    _createTextVNode(_toDisplayString(label.name) + " ", 1),
                    (label?.isChip)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: label?.chipStyle,
                          innerHTML: label?.chipLabel
                        }, null, 10, ["innerHTML"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                option: _withCtx(({ option }) => [
                  _createVNode("div", _hoisted_38, [
                    _createVNode("div", _hoisted_39, [
                      _createTextVNode(_toDisplayString(option.name) + " ", 1),
                      (option?.isChip)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: option?.chipStyle,
                            innerHTML: option?.chipLabel
                          }, null, 10, ["innerHTML"]))
                        : _createCommentVNode("", true)
                    ]),
                    (option?.disabled && _ctx.optionReason(option))
                      ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.optionReason(option)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["placeholder", "options", "onSelect", "selectedItem"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_LpButton, {
              outline: "",
              title: _ctx.$t('handoverV2.update.common.back'),
              textColor: "red-lp-300",
              isWidthFull: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openChangeVendor = false))
            }, null, 8, ["title"]),
            _createVNode(_component_LpButton, {
              title: _ctx.$t('handoverV2.update.common.save'),
              textColor: "white",
              isWidthFull: "",
              onClick: _ctx.onSaveChangeVendor,
              disabled: !_ctx.newVendor.value
            }, null, 8, ["title", "onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}